/**
 * Iter 67fg — One-time legacy-key migration helper.
 *
 * Runs once on app boot. Copies the old `drivenest:*` / `drivenest_*` localStorage
 * keys to the new `rentalcar:*` / `rentalcar_*` keys, then removes the old keys.
 * This keeps existing users' language / currency / cookie-consent / referral
 * cookie / last-search state across the brand rename instead of forcing every
 * user to re-set their preferences.
 *
 * Safe to run multiple times: it's a no-op once the legacy keys are gone.
 */

const MIGRATIONS = [
  // localStorage
  { from: "drivenest_partner_ref",        to: "rentalcar_partner_ref",        store: "local" },
  { from: "drivenest_currency",           to: "rentalcar_currency",           store: "local" },
  { from: "drivenest_lang",               to: "rentalcar_lang",               store: "local" },
  { from: "drivenest_last_search_v1",     to: "rentalcar_last_search_v1",     store: "local" },
  { from: "drivenest:view_as_vendor",     to: "rentalcar:view_as_vendor",     store: "local" },
  { from: "drivenest:recent-vendors",     to: "rentalcar:recent-vendors",     store: "local" },
  { from: "drivenest:pwa-install-dismissed", to: "rentalcar:pwa-install-dismissed", store: "local" },
  { from: "drivenest:cookie-reengage",    to: "rentalcar:cookie-reengage",    store: "local" },
  { from: "drivenest:cookie-consent",     to: "rentalcar:cookie-consent",     store: "local" },
  // sessionStorage
  { from: "drivenest_geo_applied_or_dismissed", to: "rentalcar_geo_applied_or_dismissed", store: "session" },
];

const MIGRATION_MARK = "rentalcar:legacy-migrated";

export function migrateLegacyKeys() {
  try {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(MIGRATION_MARK)) return; // already migrated this browser
    for (const m of MIGRATIONS) {
      const store = m.store === "session" ? sessionStorage : localStorage;
      const legacyValue = store.getItem(m.from);
      if (legacyValue !== null && store.getItem(m.to) === null) {
        try { store.setItem(m.to, legacyValue); } catch { /* quota — leave legacy in place */ }
      }
      try { store.removeItem(m.from); } catch { /* ignore */ }
    }
    localStorage.setItem(MIGRATION_MARK, "1");
  } catch {
    /* private-mode Safari or storage disabled — silently bail */
  }
}
